module.exports = __webpack_public_path__ + "img/collection-memoireRingsFullSizeMemoires.21a938e.webp";